export default __webpack_public_path__ + "static/media/endRound13.a65f7631.mp3";